import clsx from 'clsx'
import { DownloadLink, onDownloadLinkClick, Row } from 'components/core-v2'
import { Link } from 'react-router-dom'

import emptyStateClasses from '@/components/core-v2/organisms/empty-detail/index.module.scss'
import { PATH } from '@/const'

import classes from './index.module.scss'

interface Props {
  confirmationDetails: {
    accountId: string
    accountName: string
    date: string
    url: string
  }[]
}

export const TradeConfirmationsTab = ({ confirmationDetails }: Props) => (
  <>
    {confirmationDetails.map((detail, index) => (
      <Row
        key={detail.url}
        className={clsx(classes.row, 'flex-space-between')}
        showBottomBorder={index === confirmationDetails.length - 1}
      >
        <strong>{detail.accountId}</strong>
        <strong>{detail.accountName}</strong>
        <DownloadLink
          onClick={() =>
            onDownloadLinkClick({
              url: detail.url
            })
          }
        >
          {detail.date}
        </DownloadLink>
      </Row>
    ))}
    {confirmationDetails.length === 0 && (
      <div className={emptyStateClasses.root}>
        <strong>This note has no trades</strong>
        <p>
          You can create one <Link to={PATH.tradeBuilderNew}>using the trade builder</Link>
        </p>
      </div>
    )}
  </>
)
